import {useContext} from 'react';

import {UserContextProps, UserContext} from '@/contexts/userContext';

const useUserContext = (): UserContextProps => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error(
      'useUserContext must be used within an UserContextProvider',
    );
  }

  return context;
};

export default useUserContext;
